export default "__VITE_ASSET__BFZ2p$5C__"